<template>
  <b-row>
    <b-col cols="12">
      <b-card title="Configuração de Layouts de Importação">
        <div class="d-flex justify-content-between mb-2">
          <b-button variant="primary" @click="$router.push({ name: 'importLayoutEditor', params: { id: 'new' } })">
            <feather-icon icon="PlusIcon" class="mr-50" />
            Novo Layout
          </b-button>
        </div>

        <vue-good-table
          :columns="columns"
          :rows="layouts"
          styleClass="vgt-table striped"
          :search-options="{ enabled: true }"
          :pagination-options="{ enabled: true }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'actions'">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon rounded-circle mr-1"
                v-b-tooltip.hover
                title="Editar Layout"
                @click="$router.push({ name: 'importLayoutEditor', params: { id: props.row.id } })"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="outline-success"
                class="btn-icon rounded-circle mr-1"
                v-b-tooltip.hover
                title="Duplicar Layout"
                @click="handleDuplicate(props.row.id)"
              >
                <feather-icon icon="CopyIcon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="btn-icon rounded-circle"
                v-b-tooltip.hover
                title="Excluir"
                @click="handleDelete(props.row.id)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </span>
            <span v-else-if="props.column.field === 'tipoArquivo'">
              <b-badge :variant="fileTypeVariant(props.row.tipoArquivo)">
                {{ props.row.tipoArquivo }}
              </b-badge>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        
        <b-overlay :show="loading" no-wrap />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BButton, BBadge, BOverlay, VBTooltip } from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import { getLayouts, deleteLayout, duplicateLayout } from '@/api/financialModule/dynamicImport'
import mixinsGlobal from '@/mixins'

export default {
  components: {
    BRow, BCol, BCard, BButton, BBadge, BOverlay,
    VueGoodTable
  },
  directives: { 
    Ripple,
    'b-tooltip': VBTooltip 
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      layouts: [],
      loading: false,
      columns: [
        { label: 'ID', field: 'id', width: '70px' },
        { label: 'Nome', field: 'nome' },
        { label: 'Tipo Arquivo', field: 'tipoArquivo', width: '150px' },
        { label: 'Ações', field: 'actions', width: '180px', sortable: false }
      ]
    }
  },
  methods: {
    async fetchLayouts() {
      this.loading = true
      try {
        const response = await getLayouts()
        this.layouts = Array.isArray(response.data) ? response.data : []
      } catch (error) {
        this.layouts = []
        this.MensagemError('Erro ao carregar layouts. Verifique se o servidor está respondendo corretamente.')
      } finally {
        this.loading = false
      }
    },
    async handleDuplicate(id) {
      this.loading = true
      try {
        const response = await duplicateLayout(id)
        this.showMessageSuccess('Sucesso', 'Layout duplicado com sucesso.')
        // Redirect to editor for the new layout as requested
        this.$router.push({ name: 'importLayoutEditor', params: { id: response.data.id } })
      } catch (error) {
        this.MensagemError('Erro ao duplicar layout')
      } finally {
        this.loading = false
      }
    },
    async handleDelete(id) {
      if (await this.confirmAction('Deseja excluir este layout permanently?')) {
        this.loading = true
        try {
          await deleteLayout(id)
          this.showMessageSuccess('Sucesso', 'Layout excluído.')
          this.fetchLayouts()
        } catch (error) {
          this.MensagemError('Erro ao excluir layout')
        } finally {
          this.loading = false
        }
      }
    },
    fileTypeVariant(type) {
      const types = {
        TXT_POSICIONAL: 'light-primary',
        EXCEL: 'light-success',
        CSV: 'light-info',
        OFX: 'light-warning'
      }
      return types[type] || 'light-secondary'
    }
  },
  mounted() {
    this.fetchLayouts()
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
